import { StyleSheet } from 'aphrodite';
import {
	brandPrimary,
	brandSecondary,
	charmGray,
	destructiveHover,
	header,
	nameCircles,
	navigation,
} from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	bodyCenter: {
		display: 'flex',
		gap: '2rem',
	},
	customDesignTitle: {
		flex: 1,
	},
	featureCheckbox: {
		color: brandSecondary,
		marginTop: '0.5rem',
	},
	formControlWrap: {
		marginBottom: '1.25rem',
		...CssSelectors.allChildren(
			{
				display: 'block',
				marginBottom: '0.875rem',
			},
			'label'
		),
	},
	footer: {
		...CssSelectors.allChildren(
			{
				marginLeft: '0.5rem',
			},
			':not(:first-child)'
		),
		alignItems: 'center',
		borderTop: `1px solid ${nameCircles}`,
		display: 'flex',
		padding: `2rem 0`,
	},
	headerDisplayName: {
		color: brandPrimary,
		fontSize: '1.125rem',
		margin: '0 0 4.5rem',
	},
	headerLabel: {
		color: charmGray,
		fontSize: '0.875rem',
	},
	keywordsField: {
		marginTop: '1rem',
	},
	labelDisplayName: {
		color: header,
		fontSize: '0.875rem',
		marginRight: '0.5rem',
	},
	labelRequired: {
		'::after': {
			color: destructiveHover,
			content: '"*"',
			display: 'inline',
			marginLeft: '0.25rem',
		},
	},
	providerTextbox: {
		marginBottom: '1.25rem',
	},
	root: {
		...CssSelectors.allDescendants({
			boxSizing: 'border-box',
		}),
		boxSizing: 'border-box',
		margin: '0 auto',
		maxWidth: 1200,
		padding: '2rem',
	},
	sectionCustomDesign: {
		display: 'flex',
		flex: 2,
		flexDirection: 'column',
	},
	sectionCustomDesignHeader: {
		alignItems: 'baseline',
		display: 'flex',
		marginBottom: '0.875rem',
	},
	sectionCustomDesignMessage: {
		marginBottom: '1.25rem',
	},
	sectionCustomDesignHeaderLabel: {
		flex: 1,
	},
	sectionCustomDesignHeaderMax2GB: {
		color: header,
		fontSize: '0.75rem',
	},
	sectionIndustries: {},
	sectionMessage: {
		flex: 1,
	},
	sectionMessageCharCount: {
		color: navigation,
		display: 'flex',
		fontSize: '0.75rem',
	},
	sectionMessageCharCountOver: {
		color: 'red',
	},
});
